import { Box, InputBase, Popover, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getAllGroups, getGroups } from "../../api/group";
import { createProject, updateProject } from "../../api/project";
import CloseIcon from "../../assets/SVG/closeIcon";
import ColorInput from "../colorInput";
import CustomizedHook from "./autocomplatePro";
import DatePicker from "./datePicker";
import ProjectProgress from "./projectProgress";

export function InputCreateProject({ label, placeholder, onClick,mr,width, ...props }) {
  return (
    <Box mr={mr|| ""} width="fit-content">
      <Typography
        sx={{
          color: "#000",
          fontSize: "13px",
          fontStyle: "normal",
          fontWeight: "bold",
          lineHeight: "18px",
          mb: "5px",
          
        }}
      >
        {label}
      </Typography>
      <Box onClick={onClick} width={width|| "220px"} className="inputForm">
        <InputBase
          {...props}
          sx={{ fontSize: "13px", width: "100%" }}
          placeholder={placeholder}
        />
      </Box>
    </Box>
  );
}

export default function CreateProjectPop({
  openPopover,
  setOpenPopover,
  defData,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState();
  const [projectName, setProjectName] = useState();
  const [date, setDate] = useState();
  const [groupsList, setGroupsList] = useState([]);
  const [groupsListInTrip, setGroupsListInTrip] = useState([]);
  const [colorData, setColorData] = useState({
    color: "white",
    name: "سفید",
    enum: "WHITE",
  });
  const [ownerList, setOwnerList] = useState([]);
  const [level, setLevel] = useState("one");
  const [countTrip, setCountTrip] = useState();
  // let mmd =[]
  const [trip, setTrip] = useState([
    // {
    //   selectTrip: ["mmd"],
    // },
  ]);
  // console.log(ownerList);
  useEffect(() => {
    if (defData) {
      // console.log(defData);
      setProjectName(defData.name);
      color.map((x) => {
        if (x.enum === defData.color) {
          setColorData(x);
        }
      });
    }
  }, [defData]);
  useEffect(() => {
    if (countTrip) {
      let trp = [];
      for (let i = 0; i < Number(countTrip); i++) {
        trp.push({});
      }
      setTrip(trp);
    }
  }, [countTrip]);
  const [mmd, setmmd] = useState();
  useEffect(() => {
    trip.map((x) => {
      if (x.selectTrip?.length >= 1) {
        setmmd(true);
      } else {
        setmmd(false);
      }
    });
  }, [trip]);

  const color = [
    { color: "var(--emr-black)", name: "سیاه", enum: "BLACK" },
    { color: "var(--emr-green)", name: "سبز", enum: "GREEN" },
    { color: "var(--emr-blue)", name: "آبی", enum: "BLUE" },
    { color: "var(--emr-purple)", name: "بنفش", enum: "PURPLE" },
    { color: "var(--emr-yellow)", name: "زرد", enum: "YELLOW" },
    { color: "var(--emr-red)", name: "قرمز", enum: "RED" },
    { color: "var(--emr-lightblue)", name: "آبی کم رنگ", enum: "lightblue" },
  ];
  // useEffect(() => {
  //   trip = "mmd"
  // }, [groupsListInTrip]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setOpenPopover(false);
    setDate();
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const arrNumber = [
    "یک",
    "دو",
    "سه",
    "چهار",
    "پنج",
    "شش",
    "هفت",
    "هشت",
    "نه",
    "ده",
    "یازده",
  ];

  useEffect(() => {
    if (openPopover) {
      setAnchorEl(openPopover);
    }
    if (openPopover === true) {
      setAnchorEl(openPopover);
    }
  }, [openPopover]);
  // useEffect(() => {
  //   getGroups()
  //     .then((x) =>
  //       setGroupsList(
  //         x?.map((item) => ({
  //           title: item.groupName,
  //           id: item.id,
  //         }))
  //       )
  //     )
  //     .catch((z) => console.log(z));
  // }, []);
  // console.log(defData);
  // useEffect(() => {
  //   if (defData) {
  //     setProjectName(defData?.name);
  //   }
  //   // name: projectName,
  //   //                       color: colorData.enum,
  //   //                       startAt: date[0]?.toUnix() * 1000,
  //   //                       endAt: date[1]?.toUnix() * 1000,
  //   //                       trips: array,
  // }, [defData]);
  useEffect(() => {
    getAllGroups()
      .then((x) =>
        // console.log(x)
        setGroupsList(
          x?.map((item) => ({
            title: item.name,
            id: item.id,
          }))
        )
      )
      .catch((z) => console.log(z));
  }, []);
  const handleCloseInput = () => {
    setProjectName();
    setCountTrip();
    setDate();
    setColorData({
      color: "white",
      name: "سفید",
      enum: "WHITE",
    });
    setTrip([]);
  };
  return (
    <>
      <DatePicker
        sx={{ marginLeft: "-30px !important" }}
        date={date}
        setDate={setDate}
        show={showDatePicker}
        setShow={setShowDatePicker}
      />
      <Popover
        sx={{
          "& .MuiPaper-root": {
            width: "540px",
            height: "auto",
            padding: "22px 23px",
            borderRadius: "13px",
          },
          "& .MuiBackdrop-root": {
            backgroundColor: "#00000060",
          },
        }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: defData ? "top" : "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box>
          <Box
            width="fit-content"
            sx={{ cursor: "pointer" }}
            onClick={handleClose}
          >
            {" "}
            <CloseIcon />{" "}
          </Box>
          {level === "one" && (
            <>
              {defData && <ProjectProgress {...defData} />}
              <Box
                mt="20px"
                gap="10px"
                display="flex"
                flexWrap={"wrap"}
                justifyContent="space-around"
              >
                <InputCreateProject
                  placeholder={"نام پروژه را وارد کنید."}
                  label="نام پروژه"
                  value={projectName}
                  onChange={(e) => setProjectName(e.target.value)}
                />
                <InputCreateProject
                  onChange={(e) => setCountTrip(e.target.value)}
                  value={defData?.groupNames?.length || countTrip}
                  type="number"
                  placeholder={"تعداد اردو را وارد کنید."}
                  label="تعداد اردو"
                />
                <InputCreateProject
                  onClick={(e) => {
                    setShowDatePicker(e.currentTarget);
                  }}
                  value={
                    date?.length >= 2
                      ? `${date[0].year}/${date[0].month}/${date[0].day} تا ${date[1].year}/${date[1].month}/${date[1].day} `
                      : date?.length >= 1
                      ? `${date[0].day}/${date[0].month}/${date[0].year}`
                      : defData
                      ? `${defData?.startAt.split(
                          " ",
                          1
                        )} - ${defData?.endAt.split(" ", 1)}`
                      : ""
                  }
                  placeholder={"زمان شروع و پایان پروژه را انتخاب کنید."}
                  label="بازه زمانی پروژه"
                />
                {/* <InputCreateProject placeholder={"نام گروه جهادی را وارد کنید."} label="نام گروه" /> */}
                <ColorInput
                  width={"220px"}
                  color={color}
                  Color={colorData}
                  setColor={setColorData}
                />

                <button
                  onClick={() => {
                    if (
                      defData &&
                      date.length >= 2 &&
                      setProjectName !== defData.name
                    ) {
                      updateProject(defData.id, {
                        name: projectName,
                        color: colorData.enum,
                        startAt: date[0]?.toUnix() * 1000,
                        endAt: date[1]?.toUnix() * 1000,
                      })
                        .then(() => handleClose())
                        .catch(() => {});
                    } else {
                      date?.length >= 2 && countTrip && projectName
                        ? setLevel("two")
                        : setLevel("one");
                    }
                  }}
                  style={
                    date?.length >= 2 && countTrip && projectName
                      ? {}
                      : { opacity: "0.5", cursor: "no-drop" }
                  }
                  className="btnCreate"
                >
                  {"مرحله بعدی"}
                </button>
              </Box>
            </>
          )}
          {level === "two" && (
            <>
              {trip?.map((item, index) => (
                <>
                  <Typography
                    color="#126E83"
                    fontWeight="bold"
                    mb="10px"
                    mt="20px"
                  >{`اردو ${arrNumber[index]}`}</Typography>
                  <Box
                    gap="10px"
                    display="flex"
                    flexWrap={"wrap"}
                    justifyContent="space-around"
                  >
                    {/* <InputCreateProject
                      placeholder={"نام پروژه را وارد کنید."}
                      label="نام پروژه"
                    /> */}
                    <CustomizedHook
                      placeholder={"نام گروه های جهادی را انتخاب کنید."}
                      label="انتخاب گروه ها"
                      options={groupsList}
                      onChange={(event, newValue) => {
                        setTrip((z) => {
                          let array = [...z];
                          array[index].selectTrip = newValue;
                          return array;
                        });
                      }}
                      value={trip[index].selectTrip}
                    />
                    <CustomizedHook
                      onChange={(event, newValue) => {
                        setTrip((z) => {
                          let array = z[index].selectTrip;
                          array = array.map((x) => {
                            x.access = false;
                            if (
                              newValue.find((y) => {
                                return y.id === x.id;
                              })
                            ) {
                              x.access = true;
                            }
                            return x;
                          });
                          z[index].selectTrip = array;
                          return z;
                        });
                      }}
                      options={trip[index].selectTrip}
                      placeholder={"نام گروه‌های جهادی را انتخاب کنید."}
                      label="انتخاب گروه‌/گروه‌های مسئول"
                    />
                  </Box>
                </>
              ))}
              <button
                onClick={() => {
                  if (defData) {
                    setOpenPopover(false);
                  }
                  if (mmd) {
                    // setOwnerList(() => {
                    let array = [...trip];
                    array = array.map((x) => {
                      return x.selectTrip?.map((z) => {
                        return {
                          owner: z.id,
                          writeAccess: z.access,
                        };
                      });
                    });
                    // console.log(array);
                    createProject({
                      name: projectName,
                      color: colorData.enum,
                      startAt: date[0]?.toUnix() * 1000,
                      endAt: date[1]?.toUnix() * 1000,
                      trips: array,
                    })
                      .then((x) => {
                        setLevel("one");
                        handleClose();
                        handleCloseInput();
                      })
                      .catch((z) => console.log(z));
                  }
                  //   return array;
                  // })
                }}
                style={mmd ? {} : { opacity: "0.5", cursor: "no-drop" }}
                className="btnCreate"
              >
                {"ایجاد پروژه"}
              </button>
            </>
          )}
        </Box>
      </Popover>
    </>
  );
}
